jQuery(document).ready(function ($) {
    // image alt
    $('img').each(function () {
        var img = $(this);
        var src = $(this).attr('src');
        var alt = $(this).attr('alt');
        var filename = src.split('/').reverse()[0].replace(/\..+$/, '');
        if (img.parent('a').length !== 0) {
            console.log('parent is a link');
            if (alt === '' || alt === undefined) {
                img.attr('alt', 'image ' + filename);
            }
        } else {
            if (alt === '' || alt === undefined) {
                img.attr('alt', '');
            }
        }
    });

    // breadcrumbs
    // $('ul.breadcrumb').prepend('<li><a href="/">Home</a></li>');

    //View More for Directory
    $('.bio-content-toggle').click(function () {
        var $bio = $(this).parent();
        var $toggletext = $(this).children('.text');

        if ($bio.hasClass('expanded')) {
            $bio.removeClass('expanded');
            $toggletext.text("View More");
        } else {
            $bio.addClass('expanded');
            $toggletext.text("View Less");
        }
    });

    var $multiCampus = $('select#chooseCampuses.multi-select');

    $multiCampus.multi({
        enable_search: true,
        "non_selected_header": "Available Campuses",
        "selected_header": "Selected Campuses",
        "search_placeholder": "Filter Campuses..."
    });

    var $multi = $('select#chooseDisciplines.multi-select');

    $multi.multi({
        enable_search: true,
        "non_selected_header": "Available Disciplines",
        "selected_header": "Selected Disciplines",
        "search_placeholder": "Filter Disciplines..."
    });
    $('span.required').each(function () {
        var label = $(this).siblings('label');

        if (label.length == 1) {
            label.addClass('required');
        }
    });

    //Tabs - remove tab link if there is only one
    if ($('ul.tab-list li').length <= 1) {
        $('ul.tab-list li > a').replaceWith(function () {
            return $('<span/>', {
                html: this.innerHTML
            });
        });

    }

    //Tooltip popover
    $(function () {
        $('[data-toggle="popover"]').popover();
    });

});